import { Action } from '@ngrx/store';

export const ADD_NOTE_ACTION = 'ADD_NOTE_ACTION';

export class AddNoteActions implements Action {
  readonly type = ADD_NOTE_ACTION;
  constructor(public payload: any) {}
}
